export default __webpack_public_path__ + "static/media/coming-canada.5ac01b39.jpg";